<template>
<div class="page_set page">
    <div class="list erji" v-if="!isAuth">
        <div class="item">
            <div class="name">员工编号：</div>
			<div class="bianhao">
				<van-field v-model="staffCode" placeholder="例：RC-34103"/>
			</div>
        </div>
        <div class="item" v-if="!isAuth&&canVerify">
            <div class="name" >员工手机号：</div>
			<div class="bianhao">
                <van-cell :title="staffPhone" />
			</div>
        </div>
        <div class="item" v-if="!isAuth&&canVerify">
            <div class="name">验证码：</div>
            <div class="code"><van-field v-model="code" placeholder="请填写手机验证码"/></div>
            <div class="action" @click="getCode">获取验证码</div>
        </div>
    </div>
    <div class="list erji" v-if="isAuth">
        <div class="item" >
            <div class="name" >员工编号：</div>
			<div class="bianhao">
                <van-cell :title="staffInfo.staff_num" />
			</div>
        </div>
        <div class="item" >
            <div class="name" >手 机 号：</div>
			<div class="bianhao">
                <van-cell :title="staffInfo.phone" />
			</div>
        </div>
        <div class="item" >
            <div class="name" >公司地址：</div>
			<div class="bianhao">
                <van-cell :title="staffInfo.address" />
			</div>
        </div>
    </div>
	<div class="big_btn btn" v-if="!isAuth&&!canVerify" @click="getCanVerifyInfo">认证员工号</div>
    <div class="big_btn btn" v-if="!isAuth&&canVerify" @click="verifyStaff">认证</div>
    <!-- <div class="big_btn btn" v-if="isAuth" @click="unbindStaff">解绑</div> -->
	<!-- 绑定成功,提示卡余额 -->
	<van-overlay :show="showMoney" class-name="tips-overlay">
		<div class="tips-wrap">
			<div class="tips-t">
				<div class="money-num">¥{{ cardMoney }}</div>
				<div class="tips-text">认证成功</div>
			</div>
			<div class="tips-b">知道了</div>
		</div>
	</van-overlay>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-staff",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
            token: null,
            staffCode: '', // 编号
            code: '', // 验证码
            isAuth: false,//是否已认证
            staffInfo: {},//已认证的员工信息
            canVerify: false,//是否可以认证
            staffPhone: '',
			showMoney: false,
			cardMoney: '', // 员工卡里的钱
			codeLoading: false,
			delyTime: 5 // 获取验证间隔时间 s
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token
                        this.getStaffData()
                    }
                })
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getStaffData()
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '员工认证',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
        },
        //员工是否认证
        getStaffData() {
            var params = {
                token: this.token
            }
            this.$api.my.staffIsAuth(params).then(res => {
                if (res.code == 200) {
                    if (res.result == null || res.result == undefined || res.result == '') {
                        this.isAuth = false
                    } else {
                        this.isAuth = true
                        this.staffInfo = res.result
                        console.log(this.staffInfo)
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //员工code是否可以认证
        getCanVerifyInfo() {
			let that = this;
			if(!this.staffCode){
				this.$toast('请输入员工编号');
				return
            }
            var params = {
                token: this.token,
                staff_num: this.staffCode
            }
            this.$api.my.staffVerify(params).then(res => {
                if (res.code == 200) {
                    if (res.result == null || res.result == undefined || res.result == '') {
                        this.canVerify = false
                    } else {
                        this.canVerify = true
                        this.staffPhone = res.result
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //认证员工
        verifyStaff() {
			let that = this;
            if(!this.staffCode){
				this.$toast('请输入员工编号');
				return
            }
            if(!this.code){
				this.$toast('请输入验证码');
				return
            }
            let params = {
                token: this.token,
                staff_num: this.staffCode,
                code: this.code
            }
            this.$api.my.staffAuth(params).then(res => {
                if (res.code == 200) {
					that.cardMoney = res.result;
					that.showMoney = true;
					setTimeout(function(){
						that.showMoney = false;
						that.$router.push('/')
					},1000);
                } else {
                    this.$toast(res.message)
                }
            })
        },
        unbindStaff() {
            var params = {
                token: this.token,
            }
            this.$api.my.unBindStaff(params).then(res => {
                if (res.code == 200) {
                    this.getStaffData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
		// 获取验证码
		getCode(){
			let that = this;
			if(that.codeLoading){
				return;
			};
            let param = {
                'phone': that.staffPhone,
                'type': '0'
			};
			that.codeLoading = true
            that.$api.user.code(param).then(res => {
                if (res.code === 200) {
					that.$toast('已发送');
					let s = setInterval(function () {
						let dely1 = parseInt(that.delyTime) - 1;
						that.delyTime = dely1;
						if (dely1 == 0) {
							clearInterval(s);
							that.codeLoading = false;
							that.delyTime = 5;
						}
					}, 1000);
                } else {
                    that.$toast(res.message);
					that.codeLoading = false;
                }
			})
		},
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
